<template>
    <div class="mb-4 dm-upload-wrap">
        <div class="form-group">
            <label>{{ translate("Upload New Illustration") }}</label>
            <div></div>
            <div class="custom-file">
                <input
                    type="file"
                    class="custom-file-input"
                    id="add-new-document"
                    @change="onFileSelected"
                    :disabled="uploading"
                />
                <label for="add-new-document" class="custom-file-label">{{
                    translate("Choose file")
                }}</label>
            </div>
            <div class="py-4 my-4" v-if="uploading">
                <div
                    class="spinner spinner-track spinner-info spinner-lg"
                ></div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: ["type", "presentation_id"],
    data() {
        return {
            file: null,
            uploading: false,
        };
    },
    methods: {
        onFileSelected(event) {
            this.file = event.target.files[0];

            this.uploadFile();
        },

        uploadFile() {
            var self = this;

            self.uploading = true;
            axios
                .post(
                    "/api/author/presentations/" +
                        this.presentation_id +
                        "/illustrations",
                    this.makeFormData(),
                )
                .then(function (response) {
                    self.$emit("illustrationUploaded", response.data.id);
                    self.showSwalSuccessPopup();
                    self.uploading = false;
                })
                .catch(function (error) {
                    console.log(error);
                    self.uploading = false;
                });
        },

        makeFormData() {
            let formData = new FormData();

            if (this.file) {
                formData.append("file", this.file);
                // formData.append('type', this.type);
            }

            return formData;
        },
    },
};
</script>
